import React from 'react';
import { PRODUCT_TYPES } from '../../../constants';

const ProductCategoryNav = React.memo(({ 
  activeTypeTab, 
  handleTabChange, 
  isMontajci, 
  products, 
  isLoading 
}) => {
  return (
    <div className="product-nav-container">
      {Object.entries(PRODUCT_TYPES)
        .filter(([key]) => {
          if (isMontajci) return key === 'plise';
          return true;
        })
        .map(([key, type]) => {
          const count = products.filter(p => p.productType === key).length;
          return (
            <button
              key={key}
              className={`nav-pill ${activeTypeTab === key ? 'active' : ''}`}
              onClick={() => handleTabChange(key)}
            >
              <i className={`fas fa-${key === 'tul' ? 'scroll' :
                key === 'kanat' ? 'border-all' :
                  key === 'ahsapJaluzi' ? 'align-justify' :
                    key === 'metalJaluzi' ? 'th-list' :
                      key === 'stor' ? 'window-maximize' :
                        key === 'zebra' ? 'equals' :
                          key === 'dikeyPerde' ? 'columns' :
                            key === 'plise' ? 'layer-group' :
                              key === 'raySistemi' ? 'road' :
                                key === 'rustik' ? 'ellipsis-h' : 'box'
                }`}></i>
              {type.label}
              <span className={`tab-count ${isLoading ? 'loading' : ''} ${!isLoading && count === 0 ? 'empty' : ''}`}>
                {isLoading ? '...' : count}
              </span>
            </button>
          );
        })}
    </div>
  );
});

export default ProductCategoryNav;
